import { Alert, Stack, Typography } from "@mui/material";
import type { MembersChangeRequestView } from "../../../../../api/types/membersChangeRequestTypes";
import MemberChangesSections from "./MemberChangesSections";

interface Props {
  changeRequest: MembersChangeRequestView;
}

const MemberChangeRequestDetails = ({ changeRequest }: Props) => (
  <Stack spacing={2.5}>
    <Stack spacing={1.5}>
      <Typography variant="subtitle1">Comment</Typography>
      {changeRequest.comment ? (
        <Alert severity="info" icon={false}>
          <Typography variant="caption" sx={{ whiteSpace: "pre-wrap" }}>
            {changeRequest.comment}
          </Typography>
        </Alert>
      ) : (
        <Typography color="textSecondary">No notes added</Typography>
      )}
    </Stack>
    <MemberChangesSections changeRequest={changeRequest} />
  </Stack>
);

export default MemberChangeRequestDetails;
